export const Settings = {
  // Cleopatra's Fire base game and free spins are a 5x4 grid (GDD §1).
  // Everything downstream derives from these: GAME_LAYOUT below, SPRITE_COUNT
  // in ReelControllerV2 (SYMBOLS_VISIBLE*2+2), the flat overlay's cell grid,
  // and DEFAULT_SLOTFACE in SymbolData.
  REEL_COUNT: 5,
  SYMBOLS_VISIBLE: 4,
  // Hold & Win plays on its own, taller grid: 5x8 (GDD §8.1). The bottom 4
  // rows start active, the top 4 are locked and open upward. Nothing reads
  // this yet — the H&W reel set will, instead of the base grid above.
  HOLD_AND_WIN: {
    REEL_COUNT: 5,
    SYMBOLS_VISIBLE: 8,
  },
  // One cell = one row of the reel frame's window. The window inside
  // game_view's `reels_bg` is 1079 x 857 spine units (measured from the atlas
  // pixels), i.e. 857 / 4 = 214.25 per row. The whole game_view scene is drawn
  // at cell / SYMBOL_HEIGHT, so at 214 four cells fill the window top to
  // bottom and five fill it side to side (1079 / 214 = 5.04).
  //
  // Symbol ART size inside the cell is SYMBOL_SCALE_OVERRIDES below, never
  // this — changing this moves the frame with the symbols.
  //
  // WIDTH is the reel PITCH (2026-09-29). The new reel backgrounds
  // (reelbg_base / reelbg_freegame, 1092 wide) paint the reel dividers into
  // their hieroglyph pattern: every 3rd column line, at −323 / −108 / +107 /
  // +325 units from the centre — a 216 pitch, centred (measured from the atlas
  // pixels, both rooms alike). At 214 the reels drifted off those lines, 1
  // unit on the inner ones and 3 on the outer. Height stays 214, so the scene
  // scale and the symbol art size do not change.
  // SYMBOL_WIDTH: 214,
  SYMBOL_WIDTH: 216,
  SYMBOL_HEIGHT: 214,
  // Per-category scale multipliers. Keys match symbolData.symbolPay values.
  // Unlisted categories fall back to DEFAULT.
  //
  // This is the knob that sizes the SYMBOLS inside their cells. Do NOT use
  // SYMBOL_WIDTH/HEIGHT for that: the whole game_view scene is scaled by
  // cell / SYMBOL_HEIGHT too, so changing it moves the reel frame with the
  // symbols (tried 264, 2026-09-28 — the frame shrank around the grid).
  //
  // 216 / 218: the high-pay stone (218 native in h.json) fills its 214 cell
  // plus two units, so the stones sit edge to edge inside the frame window
  // (window columns are 215.8 wide, rows 214.25 tall — the small overlap
  // between rows does not show). Tuned by eye with Vladimir, 2026-09-28.
  // Read by ReelControllerV2 (textures), both overlay controllers (spines) and
  // the mini paytable, so all of them stay the same size.
  SYMBOL_SCALE_OVERRIDES: {
    DEFAULT: 216 / 218,
    // The H&W blank (`bl`, 166 x 135) is drawn at the H&W cell's own size
    // (170 x 139), not for a 214 base cell — so cancel the / SYMBOL_HEIGHT:
    // cell / 214 x 214 / 139 = the bl at its native size, filling the cell
    // (2026-10-02). Only ever on the H&W board.
    blank: 214 / 139,
  },
  // The jackpot coin's lettering size (cj `coin_major`, 2026-09-29): its letters
  // stand ~50 rig units without the lip. In Noto Sans ExtraBold (coin_value_bw)
  // digits stand 0.714 x the font size (its cap height), plus the outline
  // outside the glyph 0.138 -> 0.852 x font = 50 -> font ≈ 58.7 = 0.274 x
  // SYMBOL_HEIGHT. (0.29 was worked out for Troika, dropped from this game.)
  // COIN_VALUE_FONT_SIZE_MULTIPLIER: 0.25, // Font size for coin values as fraction of symbol height
  COIN_VALUE_FONT_SIZE_MULTIPLIER: 0.274,

  APP: {
    RGS_PROVIDER: "PopiPlay",
    GAME_NAME: "Cleopatra's Fire",
    // Every localStorage key starts with this (utils/StorageManager): the
    // platform serves its games from ONE origin, so bare keys were read across
    // games (Mad Labs sent 3 Orbs of Zeus's remembered bet, 2026-10-21). Made
    // from GAME_NAME, so a renamed game gets its own storage with no other
    // change: "Cleopatra's Fire" -> "CleopatrasFire.".
    get STORAGE_PREFIX() {
      return `${this.GAME_NAME.replace(/[^A-Za-z0-9]/g, "")}.`;
    },
    UI_THEME: "secondary",
    // Game Rules: the shared Additional Information section's
    // {RULES_VERSION} / {RULES_DATE} (utils/sharedRules).
    RULES_VERSION: "1.0",
    // RULES_DATE: "October 15, 2026",
    RULES_DATE: "November 2, 2026", // the game rules doc (2026-10-12)
  },
};

// Game layout configurationan - pre-generated arrays for reel and symbol indices
export const GAME_LAYOUT = {
  REEL_COUNT: Settings.REEL_COUNT,
  SYMBOLS_VISIBLE: Settings.SYMBOLS_VISIBLE,
  SYMBOL_INDICES: Array.from(
    { length: Settings.SYMBOLS_VISIBLE },
    (_, idx) => idx,
  ),
  REEL_INDICES: Array.from({ length: Settings.REEL_COUNT }, (_, idx) => idx),
  MIDDLE_REEL: Math.floor((Settings.REEL_COUNT - 1) / 2), // Middle reel index (for 5 reels = 2)
  SECOND_REEL: Math.floor((Settings.REEL_COUNT - 1) / 2) - 1, // Second reel index (for 5 reels = 1)
};

export const APP_VERSION = "27.04.2026 - 14:25";

// Stage dimensions - centralized configuration
export const STAGE_DIMENSIONS = {
  MAX_WIDTH: 3840, // Maximum stage width for UI constraint and background scaling
  MAX_HEIGHT: 3200, // Maximum background height (for reference)
};
